module.exports = __webpack_public_path__ + "img/blueRightArrow.c08abff4.svg";